var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup16724(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16724",
    "data-name": "Group 16724",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.633,
    height: 33.633,
    viewBox: "0 0 33.633 33.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 16.816,
    cy: 16.816,
    r: 16.816,
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10187",
    "data-name": "Path 10187",
    d: "M5221.618-7375.927v16.063l12.037-7.44Z",
    transform: "translate(-5209.318 7384.711)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup16724);
export default __webpack_public_path__ + "static/media/Group 16724.a6e4b291fe10dcaa36090e14867d00a7.svg";
export { ForwardRef as ReactComponent };